import { useCallback } from 'react';
import { toast } from 'react-toastify';
import type { CustomToastProps } from '../types';
import { snackbarType } from '../utils/toastTypeMapper';
import { SnackbarToToast } from './SnackbarToToast';

export const displayCustomToast = (args: Omit<CustomToastProps, 'variantColor' | 'type'>) => {
  const { toastType, message, autoClose: customAutoClose, ...mergedProps } = { ...args };
  const { variantColor, autoClose } = snackbarType(toastType) || {};

  if (toastType && variantColor) {
    toast(
      (item) => (
        <SnackbarToToast
          id={item.toastProps.toastId.toString()}
          message={message || ''}
          type={toastType}
          variantColor={variantColor}
          {...mergedProps}
        />
      ),
      { autoClose: customAutoClose ?? autoClose, toastId: args.id },
    );
  }
};

export const useCustomToast = () => useCallback(displayCustomToast, []);
